/**
 * Global Imports
*/

import { ChatUserstate } from 'tmi.js';

/**
 * Local Imports
*/

import { TwitchConfig } from '@config/Twitch';

/**
 * Relative Imports
*/

import { isUser } from './guards';
import { User, UserStatus } from './types';

/**
 * Public Functions
*/

/**
 * @return {boolean}
 */
export function UserIsBroadcaster(
  user: User | ChatUserstate): boolean
{
  const status: UserStatus = (
    isUser(user)
      ? (user.status)
      : (user.subscriber ? UserStatus.Subscriber : 0) | (user.mod ? UserStatus.Moderator : 0) | (user.username === TwitchConfig.channel ? UserStatus.Broadcaster : 0)
  );

  return !!(status & UserStatus.Broadcaster);
}

/**
 * @return {boolean}
 */
export function UserIsModerator(
  user: User | ChatUserstate): boolean
{
  const status: UserStatus = (
    isUser(user)
      ? (user.status)
      : (user.subscriber ? UserStatus.Subscriber : 0) | (user.mod ? UserStatus.Moderator : 0) | (user.username === TwitchConfig.channel ? UserStatus.Broadcaster : 0)
  );

  return !!(status & UserStatus.Broadcaster) || !!(status & UserStatus.Moderator);
}

/**
 * @return {boolean}
 */
export function UserIsSubscriber(
  user: User | ChatUserstate): boolean
{
  const status: UserStatus = (
    isUser(user)
      ? (user.status)
      : (user.subscriber ? UserStatus.Subscriber : 0) | (user.mod ? UserStatus.Moderator : 0) | (user.username === TwitchConfig.channel ? UserStatus.Broadcaster : 0)
  );

  return !!(status & UserStatus.Subscriber);
}

/**
 * @return {boolean}
 */
export function UserIsFollower(
  user: User | ChatUserstate): boolean
{
  const status: UserStatus = (
    isUser(user)
      ? (user.status)
      : (user.subscriber ? UserStatus.Subscriber : 0) | (user.mod ? UserStatus.Moderator : 0) | (user.username === TwitchConfig.channel ? UserStatus.Broadcaster : 0)
  );

  return !!(status & UserStatus.Follower);
}

/**
 * @return {boolean}
 */
export function UserIsVIP(
  user: User | ChatUserstate): boolean
{
  const status: UserStatus = (
    isUser(user)
      ? (user.status)
      : (user.subscriber ? UserStatus.Subscriber : 0) | (user.mod ? UserStatus.Moderator : 0) | (user.username === TwitchConfig.channel ? UserStatus.Broadcaster : 0)
  );

  return !!(status & UserStatus.VIP);
}

/**
 * @return {boolean}
 */
export function UserIsPrivileged(
  user: User | ChatUserstate): boolean
{
  const status: UserStatus = (
    isUser(user)
      ? (user.status)
      : (user.subscriber ? UserStatus.Subscriber : 0) | (user.mod ? UserStatus.Moderator : 0) | (user.username === TwitchConfig.channel ? UserStatus.Broadcaster : 0)
  );

  return !!(status & UserStatus.Broadcaster) || !!(user.status & UserStatus.Moderator);
}

/**
 * @return {boolean}
 */
export function UserIsRegular(
  user: User | ChatUserstate): boolean
{
  const status: UserStatus = (
    isUser(user)
      ? (user.status)
      : (user.subscriber ? UserStatus.Subscriber : 0) | (user.mod ? UserStatus.Moderator : 0) | (user.username === TwitchConfig.channel ? UserStatus.Broadcaster : 0)
  );

  return !(status & UserStatus.Broadcaster) && !(user.status & UserStatus.Moderator);
}

/**
 * @return {User}
 */
export function UserCreate(
  state: ChatUserstate): User
{
  return {
    state,
    id: state.id,
    name: state['display-name'],
    login: state.username,
    status: (state.subscriber ? UserStatus.Subscriber : 0) | (state.mod ? UserStatus.Moderator : 0) | (state.username === TwitchConfig.channel ? UserStatus.Broadcaster : 0),
    color: state.color,
  };
}

export function UserGetName(
  user: User | ChatUserstate): string
{
  return isUser(user) ? user.name : user['display-name'];
}
